import { GDMState, IGraphic, GraphicConfig, IGraphicGDM } from "@/libs/graphics/types/Graphics.t";
import { MutationTree } from "vuex";
import { MutationTypesGDM } from "./types";
/**
 * This file holds functions that performs actual state modifications
 * Please refer to https://vuex.vuejs.org/guide/mutations.html for more information
 */

export type UpdateGDMPayload = {
  componentIdx: number
  data: IGraphicGDM
}

export type MutationsGDM<S = GDMState> = {
  [MutationTypesGDM.CLEAR_CONFIG_STATE_IN_TRANSFER_DESIGN](state: S): void
  [MutationTypesGDM.SET_GDM_CONFIG](state: S, payload: GraphicConfig): void
  [MutationTypesGDM.SET_GDM](state: S, payload: IGraphicGDM): void
  [MutationTypesGDM.UPDATE_GDM](state: S, payload: UpdateGDMPayload): void
}

const mutations: MutationTree<GDMState> & MutationsGDM = {

  [MutationTypesGDM.CLEAR_CONFIG_STATE_IN_TRANSFER_DESIGN](state) {
    state.config = [];
  },

  [MutationTypesGDM.SET_GDM_CONFIG](state, payload) {
    state.config.push(payload);
  },

  [MutationTypesGDM.SET_GDM](state, payload) {
    state.data.push(payload);
  },

  [MutationTypesGDM.UPDATE_GDM](state, payload) {
    if (!state.data[payload.componentIdx]) return false;
    state.data.splice(payload.componentIdx, 1, payload.data);
  }
};

export default mutations;
